import { HTTPService, httpService } from "../../services/http.service";
import { AnomalyDataObject } from '../models/data/anomalies'
import { ChartType } from "../../models/charts/chart-type.enum";
import { anomaliesListFromDataObject } from '../transforms/anomalies'
import { TimeRange } from "../../models/time-range.enum";
import { Anomalies } from "../models/anomalies";
import { AnomalyNewsDataObject } from "../models/data/news";
import { News } from "../models/news";
import { newsListFromDataObject } from "../transforms/news";

export class AnomaliesService {
    private timeRange: TimeRange = TimeRange.Month
    constructor(private httpService: HTTPService) { }

    async load(chartType: ChartType): Promise<Anomalies[]> {
        const data = await this.httpService.query(`graph/${chartType}/anomalies?time_range=${this.timeRange}`, "GET") as AnomalyDataObject
        return anomaliesListFromDataObject(data)
    }

    async loadNews(chartType: ChartType): Promise<News[] | null> {
        const data = await this.httpService.query(`graph/${chartType}/anomaly_news?time_range=${this.timeRange}`, "GET") as AnomalyNewsDataObject
        return newsListFromDataObject(data)
    }
}
export const anomaliesService = new AnomaliesService(httpService)